import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
 import { FolderOpen, Compass, Store, Star } from 'lucide-react';
import { useMembership } from '@/contexts/MembershipContext';

export function MainNav() {
  const location = useLocation();
  const { capabilities } = useMembership();
  
  const isMyCollections = location.pathname === '/' || location.pathname.startsWith('/collection/');
  const isExplore = location.pathname === '/explore' || location.pathname.startsWith('/explore/');
   const isMarketplace = location.pathname === '/marketplace';
  const isFavorites = location.pathname === '/favorites';

  return (
    <nav className="flex items-center gap-1">
      {/* Only show My Collections if user can create collections */}
      {capabilities.canCreateCollections && (
        <Link
          to="/"
          className={cn(
            "flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors",
            isMyCollections
              ? "bg-primary/10 text-primary"
              : "text-muted-foreground hover:text-foreground hover:bg-muted"
          )}
        >
          <FolderOpen className="h-4 w-4" />
          <span className="hidden sm:inline">My Collections</span>
        </Link>
      )}
      <Link
        to="/explore"
        className={cn(
          "flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors",
          isExplore
            ? "bg-primary/10 text-primary"
            : "text-muted-foreground hover:text-foreground hover:bg-muted"
        )}
      >
        <Compass className="h-4 w-4" />
        <span className="hidden sm:inline">Explore</span>
      </Link>
      {/* Only show Marketplace if user has Curator tier */}
      {capabilities.canUseMarketplace && (
        <Link
          to="/marketplace"
          className={cn(
            "flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors",
            isMarketplace
              ? "bg-green-500/10 text-green-600"
              : "text-muted-foreground hover:text-foreground hover:bg-muted"
          )}
        >
          <Store className="h-4 w-4" />
          <span className="hidden sm:inline">Marketplace</span>
        </Link>
      )}
      {/* Only show Favorites if user can use favorites (not Explorer tier) */}
      {capabilities.canUseFavorites && (
        <Link
          to="/favorites"
          className={cn(
            "flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors",
            isFavorites
              ? "bg-amber-500/10 text-amber-600"
              : "text-muted-foreground hover:text-foreground hover:bg-muted"
          )}
        >
          <Star className="h-4 w-4" />
          <span className="hidden sm:inline">Favorites</span>
        </Link>
      )}
    </nav>
  );
}
